var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 115,
    viewBox: "0 0 220 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAEDE2",
    d: "M210.778 19.593c5.093 0 9.222 4.167 9.222 9.307 0 5.14-4.129 9.308-9.222 9.308h-52.694c5.093 0 9.221 4.167 9.221 9.308 0 5.14-4.128 9.307-9.221 9.307h28.982c5.093 0 9.221 4.168 9.221 9.308s-4.128 9.308-9.221 9.308h-13.403c-6.421 0-11.627 4.167-11.627 9.307 0 3.427 2.635 6.53 7.904 9.308 5.093 0 9.222 4.167 9.222 9.308 0 5.14-4.129 9.308-9.222 9.308H60.6c-5.093 0-9.222-4.168-9.222-9.308s4.129-9.308 9.222-9.308H9.222C4.129 94.054 0 89.887 0 84.746c0-5.14 4.129-9.307 9.222-9.307h52.694c5.093 0 9.222-4.167 9.222-9.308 0-5.14-4.129-9.308-9.222-9.308H28.982c-5.093 0-9.222-4.167-9.222-9.307 0-5.14 4.13-9.308 9.222-9.308h52.695c-5.093 0-9.222-4.167-9.222-9.308 0-5.14 4.129-9.307 9.222-9.307h129.101zm-.086 37.23c5.14 0 9.308 4.168 9.308 9.308s-4.167 9.308-9.308 9.308c-5.14 0-9.307-4.167-9.307-9.308 0-5.14 4.167-9.308 9.307-9.308z",
    transform: "translate(0 2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2) translate(60)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.586,
    cy: 41.586,
    r: 42.586,
    fill: "#DCEFB9",
    fillOpacity: 0.592,
    stroke: "#194742",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#194742",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M34.923 73.854c2.183.403 4.404.613 6.663.629 18.168 0 32.897-14.729 32.897-32.897S59.754 8.69 41.586 8.69c-4.667 0-9.107.972-13.129 2.724-6.989 3.045-12.714 8.448-16.172 15.204-2.299 4.49-3.595 9.578-3.595 14.968 0 4.891 1.067 9.533 2.982 13.705 1.366 2.979 3.165 5.718 5.315 8.138"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#194742",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M20.852 67.127c2.667 2.168 5.68 3.926 8.942 5.18M42.207 18.62c-2.139 0-4.21.285-6.18.819-10.029 2.715-17.406 11.88-17.406 22.768"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#194742",
    strokeWidth: 2,
    d: "M75.724 74.483L83.172 81.931"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0EEBE",
    fillOpacity: 0.618,
    stroke: "#194742",
    strokeWidth: 2,
    d: "M90.867 80.337c-1.282-1.282-2.963-1.924-4.644-1.924s-3.362.642-4.644 1.924c-1.283 1.283-1.924 2.964-1.924 4.645 0 1.68.641 3.361 1.924 4.644l13.76 13.761c1.283 1.283 2.964 1.924 4.645 1.924 1.68 0 3.362-.641 4.644-1.924 1.283-1.283 1.924-2.963 1.924-4.644s-.641-3.362-1.924-4.645l-13.76-13.76z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#004842",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M89.681 86.664L98.043 94.991"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIcon);
export default __webpack_public_path__ + "static/media/empty-icon.489911d8a6d8652d4d3e221a0990fced.svg";
export { ForwardRef as ReactComponent };